<div
    class="nav-menu-item {{ category.className }}"
    [class.is-active]="(!!activeCategories && activeCategories[sectionIndex]?.activeCategoryIdLvl1 === category.id) || category.isBlockCategories"
    [class.js-expanded-scope]="isExpandedScope === 'open'"
    [class.js-collapsed-scope]="isExpandedScope === 'close'"
    [class.has-childs]="hasChild"
    [class.is-rtl]="isRtl"
    [style.--color]="category.labelColor"
    [style.--bg-color]="category.backgroundColor"
    [class.border-menu-category]="category.borderMenuCategory"
    [class.blinking-point]="category.blinkingPoint"
    [class.has-light]="isLight"
>
    <div class="nav-menu-item-category">
        @if (!this.isNoindex) {
            <a
                [id]="category.id"
                [title]="category.name + ' ' + sectionName | headerItemTitle"
                [href]="category.locationPath"
                class="mn-list-item"
                [class.is-rtl]="isRtl"
                [class.has-subcategories]="category.subcategories.length !== 0"
                (click)="
                    toggleCategory(
                        $event,
                        category,
                        sectionIndex,
                        !!activeCategories && activeCategories[sectionIndex]?.activeCategoryIdLvl1 === category.id
                    )
                "
            >
                <span class="category-name">{{ category.name }}</span>
                <span *ngIf="debugShowCategoryId">{{ category.id }}</span>
                <div class="is-flex">
                    <div class="p-tag pl-8" [class.mr-16]="hasChild || freeTextAttachments?.length > 0" *ngIf="category.isNew">NEW</div>
                    <div
                        class="p-tag pl-8"
                        [class.mr-16]="hasChild || freeTextAttachments?.length > 0"
                        *ngFor="let freeTextAttachment of freeTextAttachments"
                        [style.color]="category.labelColor"
                    >
                        {{ freeTextAttachment.path }}
                    </div>
                    <div class="icon-plus" *ngIf="hasChild">
                        <md-icon name="plus"></md-icon>
                    </div>
                    <div class="icon-minus icon-absolute" *ngIf="hasChild">
                        <md-icon name="minus"></md-icon>
                    </div>
                </div>
            </a>
        } @else {
            <div
                [id]="category.id"
                [title]="category.name + ' ' + sectionName | headerItemTitle"
                class="mn-list-item no-idex-item cursor-pointer"
                [class.is-rtl]="isRtl"
                [style.color]="category.labelColor"
                (click)="
                    toggleCategory(
                        $event,
                        category,
                        sectionIndex,
                        !!activeCategories && activeCategories[sectionIndex]?.activeCategoryIdLvl1 === category.id
                    )
                "
            >
                <span class="category-name">{{ category.name }}</span>
                <div class="is-flex">
                    <div class="p-tag pl-8" [class.mr-16]="hasChild || freeTextAttachments?.length > 0" *ngIf="category.isNew">NEW</div>
                    <div
                        class="p-tag pl-8"
                        [class.mr-16]="hasChild || freeTextAttachments?.length > 0"
                        *ngFor="let freeTextAttachment of freeTextAttachments"
                        [style.color]="category.labelColor"
                    >
                        {{ freeTextAttachment.path }}
                    </div>
                    <div class="icon-plus icon-absolute" *ngIf="hasChild">
                        <md-icon name="plus"></md-icon>
                    </div>
                    <div class="icon-minus icon-absolute" *ngIf="hasChild">
                        <md-icon name="minus"></md-icon>
                    </div>
                </div>
            </div>
        }
    </div>

    <ul
        class="nav-submenu-list"
        [id]="'nav-submenu-list-' + category.id"
        *ngIf="category.subcategories?.length > 0"
        [class.active]="(!!activeCategories && activeCategories[sectionIndex]?.activeCategoryIdLvl1 === category.id) || category.isBlockCategories"
    >
        <ng-container *ngFor="let subCategory of category.subcategories; index as i">
            @if (!subCategory.isDivider) {
                <li
                    header-menu-subcategory
                    [indexItem]="i"
                    [sectionIndex]="sectionIndex"
                    [activeCategories]="activeCategories"
                    [sectionName]="sectionName"
                    [isRtl]="isRtl"
                    [subCategory]="subCategory"
                    [debugShowCategoryId]="debugShowCategoryId"
                    (sendOpenSubCategory)="openSubCategory($event)"
                ></li>
            } @else {
                <div [ngClass]="subCategory.className"></div>
            }
        </ng-container>
    </ul>
</div>
